import { render, staticRenderFns } from "./batchImportCase.vue?vue&type=template&id=bb37bd58&scoped=true&"
import script from "./batchImportCase.vue?vue&type=script&lang=js&"
export * from "./batchImportCase.vue?vue&type=script&lang=js&"
import style0 from "./batchImportCase.vue?vue&type=style&index=0&id=bb37bd58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb37bd58",
  null
  
)

export default component.exports